<template>
<div class='register-view login-form'>
  <h1>邮箱注册</h1>

  <el-form ref="form" :model='form' :rules="rules">
    <el-form-item prop="email" :error="errors.first('email')">
      <el-input v-model="form.email" :placeholder="$t('actions.findPassword.placeholder')">
      </el-input>
    </el-form-item>

    <el-form-item prop="password" :error="errors.first('password')">
      <el-input type='password' name='password' v-model="form.password" :placeholder="$t('placeholder.user.password')">
      </el-input>
    </el-form-item>

    <el-form-item prop="passwordConfirmation" :error="errors.first('passwordConfirmation')">
      <el-input type='password' v-model="form.passwordConfirmation" :placeholder="$t('placeholder.user.passwordConfirmation')">
      </el-input>
    </el-form-item>

    <p class='hint' v-html="$t('actions.register.term')"></p>

    <el-form-item>
      <el-button type="primary submit-btn" @click.native="signUp">{{$t('actions.register.submit')}}</el-button>
    </el-form-item>

    <el-form-item>
      <router-link class="left" style='line-height: 1;' :to="{name: 'm_register'}">
        手机号注册
      </router-link>
      <router-link class='right' style='line-height: 1;' to="login">
        {{$t('actions.register.loginLink')}}
      </router-link>
    </el-form-item>
  </el-form>
</div>
</template>


<script>
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      form: {
        email: null,
        password: null,
        passwordConfirmation: null
      }
    }
  },
  mixins: [Validator],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'password', recursion: 'form' },
    required: ['email', 'password'],
    email: 'email'
  },
  methods: {
    signUp() {
      let vm = this

      // 前端验证
      let p1 = new Promise((resolve, reject) => {
        vm.errors.clear()
        vm.$refs['form'].validate(res => {
          res ? resolve() : reject('form')
        })
      })

      p1.then(_ => {
        vm.$store.dispatch('user/signUp', {
          email: vm.form.email,
          password: vm.form.password,
          sign_up_ref: vm.$route.query.code
        }).then(_ => {
          vm.$router.push({
            path: '/'
          })
        }).catch(err => {
          let data = err.response.data
          if (data.type === 'RecordInvalidError') {
            // 邮箱已被占用
            data.errors.forEach(err => {
              vm.errors.add(err.field, err.details.map(d => d.message).join(','))
            })
          }
        })
      }).catch(err => {
        console.log('cannot pass front validation', err)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.register-view {}</style>



// WEBPACK FOOTER //
// register.view.vue?0065293e